module.exports = __webpack_public_path__ + "img/bplay.450a8ce1.png";